import React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType, IDialogContentProps, PrimaryButton, TextField } from '@fluentui/react';
import { format } from "date-fns";

interface IErrorDialogProps {
  isOpen: boolean;
  errorText: string;
  onDismiss: () => void;
}

const ErrorDialog: React.FunctionComponent<IErrorDialogProps> = ({ isOpen, errorText, onDismiss }) => {
  const now = format(new Date(), 'dd-MM-yyyy HH:mm:ss');    
  const subject = `Fejl i Uhrevind programmet registreret ${now}`;
  const mailtoLink = `mailto:uhrevind@uhrevind.dk?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(errorText ?? '')}`;

  const dialogContentProps: IDialogContentProps = {
    type: DialogType.largeHeader,
    title: 'Ups! Der er sket en fejl',
    subText: `Du kan kontakte os via knappen nedenfor, og vi vil undersøge fejlen nærmere.`
  };

  return (
    <Dialog
      hidden={!isOpen}
      onDismiss={onDismiss}
      dialogContentProps={dialogContentProps}
      modalProps={{ isBlocking: false }}
    >
      <TextField multiline value={errorText} />
      <DialogFooter>
        <PrimaryButton text='Kontakt os' href={mailtoLink} />
        <DefaultButton text='Luk' onClick={onDismiss} />
      </DialogFooter>
    </Dialog>
  );
};

export default ErrorDialog;
